import React from 'react';

import TrimCardUI from './TrimCard';
import useAppName from '../../utils/sitecoreContext/useAppName';
import { PE_SITE_NAME, PSP_SITE_NAME } from '../../utils/constants';
import { getGtmTagValue } from '../../utils/gtmEvents';
import { variant1, variant2, variant3 } from './constants';

const getAddToCompareIdFn = trim => trim?.detIdentifier?.value;

const getPspAddToCompareIdFn = trim =>
  // add default transmission ID to product compare drawer
  trim?.defaultTransmission?.item?.fields?.detIdentifier?.value;

const TrimCardMap = ({ variant: propVariant, ...props }) => {
  const appName = useAppName();
  const trim = props?.trim;
  const trimCardStyles = {
    styledBox: {
      paddingY: ['default', 'default'],
      paddingX: ['default', 's'],
    },
  };
  const { 'data-gtm-model': gtmModel, 'data-gtm-body-style': gtmBodyStyle, 'data-gtm-category': gtmCategory } = props;
  let gtm = {
    'data-gtm-model': getGtmTagValue(trim?.gtmModelName),
    'data-gtm-trim': getGtmTagValue(trim?.gtmTrimName),
    'data-gtm-body-style': getGtmTagValue(trim?.gtmBodyStyle),
  };
  let getAddToCompareId = getAddToCompareIdFn;
  let variant;

  switch (appName) {
    case PE_SITE_NAME:
      variant = variant3;
      break;
    case PSP_SITE_NAME:
      variant = variant1;
      getAddToCompareId = getPspAddToCompareIdFn;
      gtm = {
        'data-gtm-model': getGtmTagValue(gtmModel || trim?.name),
        'data-gtm-body-style': getGtmTagValue(gtmBodyStyle || trim?.gtmBodyStyle),
        'data-gtm-category': getGtmTagValue(gtmCategory || props?.vehicleType),
      };
      break;
    default:
      variant = variant2;
  }

  return (
    <TrimCardUI
      variant={propVariant ?? variant}
      getAddToCompareId={getAddToCompareId}
      gtm={gtm}
      trimCardStyles={trimCardStyles}
      {...props}
    />
  );
};

export default TrimCardMap;
